import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { customerAuthAPI } from '../../services/api';
import { Mail, KeyRound, Lock, Eye, EyeOff, ArrowLeft, CheckCircle } from 'lucide-react';

export default function ForgotPassword() {
    const [step, setStep] = useState(1); // 1: email, 2: code+password
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleSendCode = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const res = await customerAuthAPI.forgotPassword({ email });
            setSuccess(res.data.message);
            setStep(2);
        } catch (err) {
            setError(err.response?.data?.error || 'Bir hata oluştu');
        }
        setLoading(false);
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword !== confirmPassword) {
            setError('Şifreler eşleşmiyor');
            return;
        }

        setLoading(true);
        try {
            const res = await customerAuthAPI.resetPassword({ email, code, newPassword });
            setSuccess(res.data.message);
            setTimeout(() => navigate('/giris'), 2000);
        } catch (err) {
            setError(err.response?.data?.error || 'Bir hata oluştu');
        }
        setLoading(false);
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <KeyRound size={32} />
                    <h1>Şifremi Unuttum</h1>
                    <p>{step === 1 ? 'E-posta adresinizi girin' : 'Kodunuzu ve yeni şifrenizi girin'}</p>
                </div>

                {error && <div className="auth-error">{error}</div>}
                {success && step === 2 && !error && (
                    <div className="auth-success">
                        <CheckCircle size={16} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                        {success}
                    </div>
                )}

                {step === 1 && (
                    <form onSubmit={handleSendCode} className="auth-form">
                        <div className="auth-field">
                            <Mail size={18} />
                            <input
                                type="email"
                                placeholder="E-posta adresiniz"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                            {loading ? 'Gönderiliyor...' : 'Sıfırlama Kodu Gönder'}
                        </button>
                    </form>
                )}

                {step === 2 && (
                    <form onSubmit={handleResetPassword} className="auth-form">
                        <div className="auth-field">
                            <KeyRound size={18} />
                            <input
                                type="text"
                                placeholder="6 haneli doğrulama kodu"
                                value={code}
                                onChange={e => setCode(e.target.value)}
                                maxLength={6}
                                required
                            />
                        </div>
                        <div className="auth-field">
                            <Lock size={18} />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Yeni şifre"
                                value={newPassword}
                                onChange={e => setNewPassword(e.target.value)}
                                required
                            />
                            <button type="button" className="auth-toggle-pw" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                        <div className="auth-field">
                            <Lock size={18} />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Yeni şifre (tekrar)"
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                                required
                            />
                        </div>
                        <p className="forgot-pw-hint">Şifre: en az 8 karakter, büyük harf, küçük harf ve sembol</p>
                        <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                            {loading ? 'Sıfırlanıyor...' : 'Şifremi Sıfırla'}
                        </button>
                        <button type="button" className="forgot-pw-resend" onClick={handleSendCode} disabled={loading}>
                            Kodu tekrar gönder
                        </button>
                    </form>
                )}

                <div className="auth-footer">
                    <ArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
                    <Link to="/giris">Giriş sayfasına dön</Link>
                </div>
            </div>
        </div>
    );
}
